import React from "react";

import { Avatar, CardHeader } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import { i18n } from "../../translate/i18n";

const useStyles = makeStyles(theme => ({
	title: {
		fontWeight: 700,
		fontSize: "1rem",
	},
	details: {
		display: "flex",
		flexWrap: "wrap",
		alignItems: "center",
		gap: 6,
		marginTop: 4,
	},
	labelTag: {
		padding: theme.spacing(0.25, 1),
		borderRadius: theme.borderRadius.pill,
		color: "#1C1A22",
		fontSize: "0.6875rem",
		fontWeight: 700,
		whiteSpace: "nowrap",
	},
	advisor: {
		fontSize: "0.75rem",
		color: theme.palette.text.secondary,
	},
}));

const TicketInfo = ({ contact, ticket, onClick }) => {
	const classes = useStyles();

	return (
		<CardHeader
			onClick={onClick}
			style={{ cursor: "pointer" }}
			titleTypographyProps={{ noWrap: true, className: classes.title }}
			subheaderTypographyProps={{ component: "div" }}
			avatar={
				<Avatar src={contact.profilePicUrl} alt="contact_image">
					{contact.name?.charAt(0)}
				</Avatar>
			}
			title={contact.name}
			subheader={
				<span className={classes.details}>
					{(ticket.labels || []).map(label => (
						<span
							key={label.name}
							className={classes.labelTag}
							style={{ backgroundColor: label.color || "#B9C0FF" }}
						>
							{label.name}
						</span>
					))}
					{ticket.whatsapp?.name && (
						<span className={classes.advisor}>
							{i18n.t("advisors.attendedBy", { name: ticket.whatsapp.name })}
						</span>
					)}
				</span>
			}
		/>
	);
};

export default TicketInfo;
